import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Container as oContainer, Option as oOption } from '../BestOptions/styles';

export const Container = styled(oContainer)`
  width: 100%;
`;

export const Option = styled(oOption)`
  border-bottom-color: ${ColorPalette.HEX.White};
`;
